import { Injectable } from '@angular/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { Observable, Subject } from 'rxjs'
import { CommonService } from '../../shared/services/common.service'

@Injectable({
  providedIn: 'root',
})
export class WelcomePackageService {
  private readonly emitSource = new Subject<any>()
  changeEmitted$ = this.emitSource.asObservable()
  public serchStr
  public recSource
  rfqCartId: any
  cartId
  cartId$: Observable<any> = this.activeCartFacade.getActiveCartId()
  private readonly bomDataEmit = new Subject<any>()
  serchStringEmitted$ = this.bomDataEmit.asObservable()

  private readonly bomDataAvailable = new Subject<any>()
  bomDataAvailableEmitted$ = this.bomDataAvailable.asObservable()
  public searchedProduct

  private readonly quoteUnavailabe = new Subject<any>()
  quoteUnavailabeEmitted$ = this.quoteUnavailabe.asObservable()
  public quoteNotAvailable = []

  poSearchFlag = new Subject<boolean>()
  constructor(
    private commonService: CommonService,
    private activeCartFacade: ActiveCartFacade
  ) {
    this.rfqCartId = sessionStorage.getItem('cartId-current')

    this.activeCartFacade.getActiveCartId().subscribe((success) => {
      this.cartId = success
    })
  }

  getSearchResult(str, crntPage, PAGE_SIZE, flag) {
    const urlParam = ['users', 'current', 'wpSlnoSearch', str]
    const apiUrl = this.commonService.constructUrl(urlParam)
    const apiParams = {
      searchType: flag,
      currentPage: crntPage,
      pageSize: PAGE_SIZE,
    }
    return this.commonService.getData(apiUrl, apiParams)
  }
  bomData(data, recSource) {
    this.searchedProduct = data
    this.recSource = recSource
  }

  getBomDetails(crntPage, PAGE_SIZE) {
    const urlParam = [
      'users',
      'current',
      'wpSlnoSearch',
      'bomDetails',
      this.searchedProduct,
    ];
    const apiUrl = this.commonService.constructUrl(urlParam);
    //const apiParams = { currentPage: crntPage, pageSize: PAGE_SIZE};
    return this.commonService.getData(apiUrl);
  }

  getQuoteUnavailabe(data) {
    this.quoteNotAvailable = data
  }

  getUnavailableQuot() {
    this.quoteUnavailabe.next(this.quoteNotAvailable)
  }
  addItemToCart(obj) {
    this.activeCartFacade.getActiveCartId().subscribe((success) => {
      this.cartId = success
    })
    const urlParam = ['users', 'current', 'carts', this.cartId, 'wpBomEntries']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(apiUrl, obj)
  }

  addItemToQuote(obj) {
    this.rfqCartId = sessionStorage.getItem('cartId-current')
    const urlParam = [
      'users',
      'current',
      'rfqcart',
      this.rfqCartId,
      'bomRfqEntries',
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(apiUrl, obj)
  }

  emitChange(str) {
    this.serchStr = str
  }

  emitBomDataAvailable(flag) {
    this.bomDataAvailable.next(flag)
  }
}
